module.exports = __webpack_public_path__ + "img/star@2x.ae5a6d5f.png";